/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Offernotfound3Inputs */

const id_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran tidak ditemukan`)
};

const ms_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran tidak ditemui`)
};

const da_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud ikke fundet`)
};

const de_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot nicht gefunden`)
};

const en_us2_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer not found`)
};

const es_es2_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta de catálogo no encontrada`)
};

const es_mx2_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta no encontrada`)
};

const fil_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang offer`)
};

const fr_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre de catalogue non trouvée`)
};

const it_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta non trovata`)
};

const hu_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat nem található`)
};

const nl_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod niet gevonden`)
};

const no_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud ikke funnet`)
};

const pl_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta nie znaleziona`)
};

const pt_br2_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta de catálogo não encontrada`)
};

const pt_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta não encontrada`)
};

const ro_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta nu a fost găsită`)
};

const fi_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjousta ei löydy`)
};

const sv_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudandet hittades inte`)
};

const vi_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy ưu đãi`)
};

const tr_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif bulunamadı`)
};

const cs_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídka nenalezena`)
};

const bg_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офертата не е намерена`)
};

const ru_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложение не найдено`)
};

const uk_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозицію не знайдено`)
};

const ar_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العرض غير موجود`)
};

const hi_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र नहीं मिला`)
};

const th_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบข้อเสนอ`)
};

const ja_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーが見つかりません`)
};

const zh_cn2_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项未找到`)
};

const zh_hant1_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目未找到`)
};

const ko_offerdetail_common_offernotfound3 = /** @type {(inputs: Offerdetail_Common_Offernotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Offer not found" |
*
* @param {Offerdetail_Common_Offernotfound3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_offernotfound3 = /** @type {((inputs?: Offerdetail_Common_Offernotfound3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Offernotfound3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_offernotfound3(inputs)
	if (locale === "ms") return ms_offerdetail_common_offernotfound3(inputs)
	if (locale === "da") return da_offerdetail_common_offernotfound3(inputs)
	if (locale === "de") return de_offerdetail_common_offernotfound3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_offernotfound3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_offernotfound3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_offernotfound3(inputs)
	if (locale === "fil") return fil_offerdetail_common_offernotfound3(inputs)
	if (locale === "fr") return fr_offerdetail_common_offernotfound3(inputs)
	if (locale === "it") return it_offerdetail_common_offernotfound3(inputs)
	if (locale === "hu") return hu_offerdetail_common_offernotfound3(inputs)
	if (locale === "nl") return nl_offerdetail_common_offernotfound3(inputs)
	if (locale === "no") return no_offerdetail_common_offernotfound3(inputs)
	if (locale === "pl") return pl_offerdetail_common_offernotfound3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_offernotfound3(inputs)
	if (locale === "pt") return pt_offerdetail_common_offernotfound3(inputs)
	if (locale === "ro") return ro_offerdetail_common_offernotfound3(inputs)
	if (locale === "fi") return fi_offerdetail_common_offernotfound3(inputs)
	if (locale === "sv") return sv_offerdetail_common_offernotfound3(inputs)
	if (locale === "vi") return vi_offerdetail_common_offernotfound3(inputs)
	if (locale === "tr") return tr_offerdetail_common_offernotfound3(inputs)
	if (locale === "cs") return cs_offerdetail_common_offernotfound3(inputs)
	if (locale === "bg") return bg_offerdetail_common_offernotfound3(inputs)
	if (locale === "ru") return ru_offerdetail_common_offernotfound3(inputs)
	if (locale === "uk") return uk_offerdetail_common_offernotfound3(inputs)
	if (locale === "ar") return ar_offerdetail_common_offernotfound3(inputs)
	if (locale === "hi") return hi_offerdetail_common_offernotfound3(inputs)
	if (locale === "th") return th_offerdetail_common_offernotfound3(inputs)
	if (locale === "ja") return ja_offerdetail_common_offernotfound3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_offernotfound3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_offernotfound3(inputs)
	return ko_offerdetail_common_offernotfound3(inputs)
});
export { offerdetail_common_offernotfound3 as "offerDetail.common.offerNotFound" }